import React, {useState,useEffect} from 'react'
import {useParams} from "react-router"
import {useSearchParams} from "react-router-dom"
import {GetVerifyTokenForMedicalFormPdfDownloadAction} from "../redux/actions/downloadMedicalForm/getVerifyTokenForMedicalFormPdfDownload"

const DownloadMedicalForm = () => {

  const [medicalFormData,setMedicalData]=useState()
  const [isInvalidLink,setIsInvalidlink] = useState(false)
  const {clientId}=useParams()
   const [searchParams]=useSearchParams()

   const {initGetVerifyTokenForMedicalformPdfData,getVerifyTokenForMedicalFormPdfQueryData} =GetVerifyTokenForMedicalFormPdfDownloadAction()
  console.log("jhjdh3235",clientId,"<<",searchParams.get('token'))

  useEffect(()=>{
    if(searchParams.get('token')){
          initGetVerifyTokenForMedicalformPdfData({
            clientId:parseInt(clientId),
            token:searchParams.get('token').toString()
          },(res)=>{
            //  console.log("downRes",res?.data?.getVerifyTokenForMedicalFormPdfDownload?.data?.pdfUrl)
            //  console.log("downRes",res?.data?.getVerifyTokenForMedicalFormPdfDownload?.data?.medicalFormPdfBase64)
            //  setMedicalData(res?.data?.getVerifyTokenForMedicalFormPdfDownload?.data?.medicalFormPdfBase64)
             window.location.href=res?.data?.getVerifyTokenForMedicalFormPdfDownload?.data?.pdfUrl
          },(error)=>{
             if(error){
                setIsInvalidlink(true)
             }
          })
    }
 },[searchParams])

 if(isInvalidLink){
  return (
    <div className="h-100 d-flex justify-content-center align-items-center text-center fw-bold fs-1 ">
        Invalid Link!
    </div>
    );
 }

  return (
   <>
         {
          getVerifyTokenForMedicalFormPdfQueryData?.loading ? (
             <div className='LoaderMain'>
                <div className='lds-ellipsis'>
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
             </div>
          ):(
            medicalFormData && (
              <iframe 
                style={{height:'100vh'}}
                src={`data:application/pdf;base64,${medicalFormData}`}
                width="100%"
                title='Download Medical Form'
              >
            </iframe>
            )
          )
         }
   </>
  )
}

export default DownloadMedicalForm